// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3ac2fdc7","117":"7f5f1fd5","130":"ad15c866","526":"cc8a67db","574":"46ff0f0f","756":"bdeee5ba"}[chunkId] + ".chunk.js";
};